import { isPast } from 'helpers/dates';
import { SystemText } from 'e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';

export const ObjectivesAI = ({ focus, data, setShow }) => {
    if (!data || data.length === 0) return null;

    const st = (path, ...rest) => SystemText(`Home/Widgets/WhatsHappening/ObjectivesAI/${path}`, ...rest);

    const total = data.length;
    const overdue = data.filter(s => isPast(s.due)).length;
    const colour = overdue > 0 ? 'danger' : 'green';

    let slug = 'Outstanding';

    if (overdue > 0) {
        slug += 'Overdue';
        if (overdue === 1 && total === 1) {
            slug += 'Only';
        } else if (overdue === 1) {
            slug += 'One';
        } else if (overdue === total) {
            slug += 'All';
        } else {
            slug += 'Some';
        }
    } else {
        if (total === 1) {
            slug += 'Only';
        } else if (overdue === total) {
            slug += 'All';
        } else {
            slug += 'Some';
        }
    }

    const objectiveName = total === 1 ? data[0].name : '';

    const message = st(slug, total, overdue);

    const url = total === 1 ? `/objectives/${data[0].profile_Id}/objective/${data[0].id}` : '';

    const date = total === 1 ? data[0].due : null;

    const buttonText = total === 1 ? (data[0].comments ? 'Continue' : 'Start') : undefined;

    if (total === 1) {
        setShow = undefined;
    }

    if (focus)
        return (
            <FocusTile
                tileType="objective"
                colour={overdue > 0 ? 'red' : 'green'}
                icon="fa-solid fa-sparkles"
                message={message}
                messageTwo={objectiveName}
                url={url}
                setShow={setShow}
                date={date}
                buttonText={buttonText}
            />
        );

    return <Panel colour={colour} icon="exclamation-triangle" message={message} url={url} setShow={setShow} />;
};

export default ObjectivesAI;
